<template>
  <div>
    <Head title="Create Team" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/issuance-teams">Teams</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-full" label=" Name" />
          <select-input v-model="form.feature" :error="form.errors.feature" class="pb-8 pr-6 w-full lg:w-full" label="Feature">
            <option :value="null">
              Select Feature
            </option>
            <option
              v-for="feature in features"
              :key="feature.id"
              :value="feature.id"
            >
              {{ feature.name }}
            </option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Create Team</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    features: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        feature: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/issuance-teams')
    },
  },
}
</script>
